/**
 * Public SSM API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0-private
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { EditorUrlDto } from '../model/editorUrlDto';
import { ImageFrameListItemDto } from '../model/imageFrameListItemDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ImageFrameViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:GET/api/ImageFrameView/admin/editor/{imageFrameId} AmsResource:{country}/{business}/_* 
     * @param imageFrameId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAdminEditorUrlAsync(imageFrameId: string, observe?: 'body', reportProgress?: boolean): Observable<EditorUrlDto>;
    public getAdminEditorUrlAsync(imageFrameId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EditorUrlDto>>;
    public getAdminEditorUrlAsync(imageFrameId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EditorUrlDto>>;
    public getAdminEditorUrlAsync(imageFrameId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (imageFrameId === null || imageFrameId === undefined) {
            throw new Error('Required parameter imageFrameId was null or undefined when calling getAdminEditorUrlAsync.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EditorUrlDto>(`${this.basePath}/api/ImageFrameView/admin/editor/${encodeURIComponent(String(imageFrameId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/ImageFrameView/admin/{countryId}/{businessId}/list AmsResource:{country}/{business}/_* 
     * @param countryId 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listBusinessImageFramesAsync(countryId: string, businessId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ImageFrameListItemDto>>;
    public listBusinessImageFramesAsync(countryId: string, businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ImageFrameListItemDto>>>;
    public listBusinessImageFramesAsync(countryId: string, businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ImageFrameListItemDto>>>;
    public listBusinessImageFramesAsync(countryId: string, businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling listBusinessImageFramesAsync.');
        }

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling listBusinessImageFramesAsync.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ImageFrameListItemDto>>(`${this.basePath}/api/ImageFrameView/admin/${encodeURIComponent(String(countryId))}/${encodeURIComponent(String(businessId))}/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/ImageFrameView/list AmsResource:{country}/{business} 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listImageFramesAsync(observe?: 'body', reportProgress?: boolean): Observable<Array<ImageFrameListItemDto>>;
    public listImageFramesAsync(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ImageFrameListItemDto>>>;
    public listImageFramesAsync(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ImageFrameListItemDto>>>;
    public listImageFramesAsync(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ImageFrameListItemDto>>(`${this.basePath}/api/ImageFrameView/list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
